<ion-content class="ion-padding">
  <ion-header>
    <ion-toolbar>
      <ion-title>{{"Successful Payment" | translate}}</ion-title>
    </ion-toolbar>
  </ion-header>

  <div class="ion-text-center">
    <div class="wrapper">
      <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
        <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
      </svg>
    </div>
    <h1 class="ion-text-success">{{"Payment Successfully" | translate}}</h1>
    <p>{{"Thank you, your payment is received susccesfully." | translate}}</p>
    <p>{{"Thanks for your patience and trust!" | translate}}</p>

    <ion-button class="back-button" routerLink="/">{{"Back to Homepage" | translate}}</ion-button>
  </div>


</ion-content>